import store from '@/store'

export default {
  hasRole (roles) {
    for (let role in roles) {
      if (typeof store.state.user.role !== 'undefined' && store.state.user.role.indexOf(roles[role]) > -1) {
        return true
      }
    }

    return false
  }
}
